import * as React from "react";
import TablePagination from "@mui/material/TablePagination";
import PropTypes from "prop-types";
import Pagination from "@mui/material/Pagination";
import MDTypography from "components/MDTypography";

export function CustomTablePagination({
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
}) {
  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <MDTypography variant="caption" color="text" fontWeight="regular">
      <TablePagination
        component="div"
        sx={{ fontSize: 14 }}
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </MDTypography>
  );
}

CustomTablePagination.propTypes = {
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};
